<template>
	<v-container fill-height>
		<v-row
			align="center"
			justify="center"
			v-if="loginStatus != 'loading'"
		>
			<v-col cols="12" sm="8" md="6" lg="4">
				<v-card class="elevation-3">
					<v-card-text>
						<v-text-field
							v-model="password"
							prepend-icon="lock"
							name="password"
							label="Пароль"
							type="password"
							v-on:keyup.enter="login"
						>
							<template v-slot:append-outer>
								<v-btn
									color="primary"
									@click.stop="login"
									:disabled="password.length == 0"
								>
									Войти
								</v-btn>
							</template>
						</v-text-field>
					</v-card-text>
				</v-card>
				<v-alert
					v-model="loginAlert"
					color="error"
				>
					Неверный пароль
				</v-alert>
			</v-col>
		</v-row>
		<v-row
			align="center"
			justify="center"
			v-if="loginStatus == 'loading'"
		>
			<v-col cols="12" sm="8" md="6" lg="4">
				<v-progress-linear :indeterminate="true" color="secondary"></v-progress-linear>
			</v-col>
		</v-row>
	</v-container>
</template>
<script>
	export default {
		data() {
			return {
				password: ''
			}
		},
		methods: {
			login() {
				this.$store.dispatch('retrieveToken', {
					password: this.password
				})
			}
		},
		computed: {
			loginStatus() {
				return this.$store.getters.loginStatus;
			},
			loginAlert() {
				return this.$store.getters.loginStatus == 'error'
			},
			loginRestricted() {
				return this.$store.getters.loginStatus == 'restricted'
			}
		}
	}
</script>
